import Image from '@anwb/poncho/components/image';
import { pxToRem } from '@anwb/poncho/design-tokens/style-utilities';
import styled, { DefaultThemeProps, css } from 'styled-components';

const InAssociationStyles = ({ theme }: DefaultThemeProps) => css`
	margin: ${pxToRem(theme.spacing['400'])} 0;
`;

const InAssociationImageStyles = () => css`
	display: block;
	width: 20%;
`;

export const InAssociationImage = styled(Image)`
	${InAssociationImageStyles}
`;

export const InAssociationFooter = styled.div`
	${InAssociationStyles}
`;

const IframeContainerStyles = () => css`
	iframe {
		border: 0;
		width: 100%;
	}
`;

export const IframeContainer = styled.div`
	${IframeContainerStyles}
`;
